/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Google_Drive_DescriptionInputs */

const en_google_drive_description = /** @type {(inputs: Google_Drive_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose files from your Drive to add to your Listening library.`)
};

const es_google_drive_description = /** @type {(inputs: Google_Drive_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige archivos de Drive para añadirlos a tu biblioteca de Listening.`)
};

/**
* | output |
* | --- |
* | "Choose files from your Drive to add to your Listening library." |
*
* @param {Google_Drive_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const google_drive_description = /** @type {((inputs?: Google_Drive_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Google_Drive_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_google_drive_description(inputs)
	return en_google_drive_description(inputs)
});